export default "__VITE_ASSET__U36pkcua__"